// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from 'D:/erp开发/erp/src/models/tabs';
import model_2 from 'D:/erp开发/erp/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'tabs', model: model_1 },
model_2: { namespace: '@@initialState', model: model_2 },
} as const
